import { useWalletContext } from '@/providers/WalletProvider';

export const useWallet = () => {
  const {
    brandCoins,
    btcMigRequired,
    chainInfo,
    coreGetWalletItems,
    coreWalletCoins,
    coreWalletCoinState,
    coreWalletError,
    erc20Configurations,
    findCoin,
    getUserWalletData,
    getWalletItems,
    handleGetActiveWallets,
    hasCoreWallet,
    hasNoWallet,
    hasDuplicateWallets,
    isCoinLoading,
    walletCoins,
    walletCoinState,
    walletError,
    walletInfo,
  } = useWalletContext();

  return {
    brandCoins,
    btcMigRequired,
    chainInfo,
    coreGetWalletItems,
    coreHasError: coreWalletError,
    coreWalletCoins,
    coreWalletCoinState,
    erc20Configurations,
    findCoin,
    getUserWalletData,
    getWalletItems,
    handleGetActiveWallets,
    hasCoreWallet,
    hasDuplicateWallets,
    hasNoWallet,
    hasError: walletError,
    isCoinLoading,
    walletCoins,
    walletCoinState,
    walletInfo,
  };
};
